import { Box, List } from "@mui/material";
import PropTypes from "prop-types";

export default function EditorList({ children, columns = 1, rows, direction = "row" }) {
  return (
    <Box sx={{ p: 2 }}>
      <List
        sx={[
          {
            gap: 0.25,
            p: 0,
            display: "grid",
            gridAutoFlow: direction,
          },
          !!columns && {
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
          },
          !!rows && {
            gridTemplateRows: `repeat(${rows}, minmax(0, 1fr))`,
          },
        ]}
      >
        {children}
      </List>
    </Box>
  );
}

EditorList.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.number,
  rows: PropTypes.number,
  direction: PropTypes.oneOf(["row", "column"]),
};
